// Module
var code = "<div class=\"im-modal-container\"> <span class=\"im-modal-title\"></span> <span class=\"im-modal-content\"></span> <span class=\"im-modal-handler\"> <span class=\"im-modal-cancel\">取消</span> <span class=\"im-modal-submit\">确认</span> </span> </div>";
// Exports
module.exports = code;